'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  p {\n    margin-bottom: 0;\n  }\n'], ['\n  p {\n    margin-bottom: 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _UICheckbox = require('UIComponents/input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _colors = require('HubStyleTokens/colors');

var _clean = require('conversations-schema/sanitize/clean');

var _UIBreakString = require('UIComponents/text/UIBreakString');

var _UIBreakString2 = _interopRequireDefault(_UIBreakString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SmallNoParagraphPadding = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'ConsentToCommunicate__SmallNoParagraphPadding'
})(_templateObject);

var ConsentToCommunicate = function ConsentToCommunicate(_ref) {
  var message = _ref.message,
      companyName = _ref.companyName,
      consentToCommunicate = _ref.consentToCommunicate,
      onChange = _ref.onChange;

  var cleanMessage = (0, _clean.clean)(message) || _I18n2.default.text('conversationsUI.GDPR.consentToCommunicate.default', {
    accountName: companyName
  });
  return _react2.default.createElement(
    'div',
    { className: 'm-top-2' },
    _react2.default.createElement(
      _UICheckbox2.default,
      { size: 'small', value: consentToCommunicate, onChange: onChange },
      _react2.default.createElement(
        SmallNoParagraphPadding,
        { tagName: 'span', style: { color: _colors.FLINT } },
        _react2.default.createElement(
          _UIBreakString2.default,
          null,
          _react2.default.createElement('span', {
            dangerouslySetInnerHTML: {
              __html: cleanMessage
            }
          })
        )
      )
    )
  );
};

ConsentToCommunicate.propTypes = {
  companyName: _react.PropTypes.string,
  consentToCommunicate: _react.PropTypes.bool.isRequired,
  message: _react.PropTypes.string.isRequired,
  onChange: _react.PropTypes.func.isRequired
};

exports.default = ConsentToCommunicate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/emailCapture/ConsentToCommunicate.js
// module id = 1115
// module chunks = 2 3